/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Panel } from 'react-bootstrap';
import { routerActions } from 'react-router-redux';
import subHours from 'date-fns/sub_hours';
import subDays from 'date-fns/sub_days';
import subMonths from 'date-fns/sub_months';
import setMilliseconds from 'date-fns/set_milliseconds';
import setSeconds from 'date-fns/set_seconds';
import setMinutes from 'date-fns/set_minutes';
import getMinutes from 'date-fns/get_minutes';
import addHours from 'date-fns/add_hours';
import isEqual from 'date-fns/is_equal';
import startOfHour from 'date-fns/start_of_hour';
import format from 'date-fns/format';
import IntlMsg from 'lorautils/intl/IntlMsg';
import Toolbar from 'loracoms/Toolbar';
import Refresher from 'loracoms/Refresher';
import { callAPI } from 'lorautils/api';
import LineChart from 'loracoms/LineChart';
import Nvl from 'loracoms/Nvl';
import Conditions from './coms/Conditions';
import styles from './styles.scss';
import {
  kLastHour,
  kLastDay,
  kLastMonth,
  kGroupFuncSum,
  kGroupFuncAvg,
  kGroupFuncMax,
  kGroupFuncMin,
  kDeviceFilter,
  kGroupByTime,
  kGroupOneMin,
  kGroupTenMin,
  kGroupOneHour,
  kSeriesDevice,
} from './constants';


const propTypes = {
  appId: React.PropTypes.string.isRequired,
  dpId: React.PropTypes.string.isRequired,
  intl: React.PropTypes.any.isRequired,
  pushState: React.PropTypes.func.isRequired,
  appState: React.PropTypes.object.isRequired,
};

class DataPointTrend extends React.Component {

  constructor(props) {
    super(props);
    this.conditions = {
      timeRange: kLastDay,
      groupBy: {
        dims: [],
        func: kGroupFuncSum,
      },
      filters: [],
    };
    this.state = {
      appState: props.appState,
      conditions: this.conditions,
      status: '',
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.parseview.dptrend');
    this.handleChangeConditions = this.handleChangeConditions.bind(this);
    this.loadData = this.loadData.bind(this);
  }

  componentWillMount() {
    this.loadData();
  }

  componentWillReceiveProps(nextProps) {
    const { appState } = nextProps;
    if (appState !== this.props.appState) {
      this.setState({ appState });
    }
  }

  getFrom() {
    const { timeRange } = this.conditions;
    const now = new Date();
    switch (timeRange) {
      case kLastHour: return subHours(now, 1);
      case kLastDay: return subDays(now, 1);
      case kLastMonth: return subMonths(now, 1);
      default: return subHours(now, 1);
    }
  }

  loadData() {
    const { appId, dpId } = this.props;
    this.setState({ status: 'pending' });
    callAPI({
      endpoint: '/lora/timeseries',
      method: 'POST',
      body: {
        appid: appId,
        dps: [dpId],
        from: this.getFrom(),
        limit: 1000,
      },
    }).then((data) => {
      this.data = data;
      this.setState({
        chartData: this.toChartData(data),
        status: 'success',
      });
    }).catch(() => {
      this.setState({
        status: 'failure',
      });
    });
  }

  toChartData(data = { list: [] }) {
    const { dpId } = this.props;
    let { filters = [] } = this.conditions;
    filters = filters.filter(f => f.value && f.value.length > 0);

    // normalize
    let list = data.list.map(l => ({
      timestamp: l.timestamp,
      value: l.metrics[dpId],
      deveui: l.nodeid,
    }));
    list = _.sortBy(list, ['timestamp']);

    // filter
    if (filters.length > 0) {
      list = list.filter(d => _.some(filters, (f) => {
        if (f.type === kDeviceFilter) {
          return d.deveui.indexOf(f.value.trim().toLowerCase().replace(/[-:]/g, '')) >= 0;
        }
        return true;
      }));
    }

    const { series = [] } = this.conditions;
    let seriesList;

    // to sereis
    if (series.includes(kSeriesDevice)) {
      const devices = list.reduce((acc, l) => _.union(acc, [l.deveui]), []);
      seriesList = devices.map(device => ({
        name: device,
        list: list.map((l) => {
          if (l.deveui === device) {
            return l;
          }
          return {
            ...l,
            value: null,
          };
        }),
      }));
    } else {
      seriesList = [{
        name: dpId,
        list,
      }];
    }

    // group
    seriesList = seriesList.map((serie) => {
      let nli = [...serie.list];
      if (nli.length > 1) {
        const { groupBy = {} } = this.conditions;
        const { dims = [], func = kGroupFuncSum } = groupBy;
        if (dims.length > 0) {
          const timeDim = dims.find(d => d.type === kGroupByTime);
          if (timeDim) {
            nli = nli.map((l) => {
              let groupKey;
              if (timeDim.value === kGroupOneMin) {
                groupKey = setSeconds(setMilliseconds(l.timestamp, 0), 0);
              } else if (timeDim.value === kGroupTenMin) {
                groupKey = setMinutes(
                  setSeconds(setMilliseconds(l.timestamp, 0), 0),
                  Math.ceil(getMinutes(l.timestamp) / 10) * 10,
                );
              } else if (timeDim.value === kGroupOneHour) {
                if (isEqual(l.timestamp, startOfHour(l.timestamp))) {
                  groupKey = new Date(l.timestamp);
                } else {
                  groupKey = addHours(
                    setMinutes(setSeconds(setMilliseconds(l.timestamp, 0), 0), 0), 1);
                }
              }
              return { ...l, timestamp: groupKey };
            });
            const grped = _.groupBy(nli, 'timestamp');
            nli = _.map(grped, (items, timestamp) => {
              const values = _.map(
                items.filter(it => !_.isNil(it.value)),
                item => Number(item.value));
              let value;
              switch (func) {
                case kGroupFuncSum:
                  value = _.sum(values);
                  break;
                case kGroupFuncAvg:
                  value = _.sum(values) / values.length;
                  break;
                case kGroupFuncMax:
                  value = _.max(values);
                  break;
                case kGroupFuncMin:
                  value = _.min(values);
                  break;
                default:
                  break;
              }
              return {
                value: Number(value).toFixed(6),
                timestamp,
              };
            });
            nli = _.sortBy(nli, [x => format(x.timestamp, 'YYYY-MM-DD HH:mm:ss')]);
          }
        }
      }
      return {
        name: serie.name,
        list: nli,
      };
    });

    let categories = [];
    if (seriesList.length > 0 && seriesList[0].list.length > 0) {
      categories = seriesList[0].list.map(l => format(l.timestamp, 'YYYY-MM-DD HH:mm:ss'));
    }

    return {
      series: seriesList.map(li => ({
        name: li.name,
        data: li.list.map(d => d.value),
        connectNulls: true,
      })),
      categories,
    };
  }


  handleChangeConditions(conditions) {
    this.setState({ conditions });
    if (this.conditions.timeRange !== conditions.timeRange) {
      this.conditions = conditions;
      this.loadData();
    } else {
      this.conditions = conditions;
      this.setState({
        chartData: this.toChartData(this.data),
      });
    }
  }

  render() {
    const { appId, dpId, pushState } = this.props;
    const { conditions, chartData = {}, status, appState } = this.state;
    const { status: appStatus, data: { name: appName } = {} } = appState;
    const { series = [], categories = [] } = chartData;
    const breadcrumb = [{
      content: this.intlMsg.msg('breadcrumb.application', 'application'),
      onClick: () => pushState('/application'),
    }, {
      content: <Nvl status={appStatus} val={appName} />,
      onClick: () => pushState(`/application/${appId}/dps`),
    }, {
      content: dpId,
      active: true,
    }];
    const header = (
      <div>
        <ul className="icontools">
          <li>
            <Refresher
              onReload={this.loadData}
              reloading={status === 'pending'}
            />
          </li>
        </ul>
      </div>
    );

    return (
      <div className={styles.trend}>
        <Toolbar breadcrumb={breadcrumb} />
        <Conditions
          data={conditions}
          onChange={this.handleChangeConditions}
        />
        <Panel bsStyle="aisz-white" header={header}>
          <div className={styles.chart}>
            <LineChart
              series={series}
              categories={categories}
              xAixs={{
                type: 'time',
                axisLabel: {
                  formatter: x => format(x, 'YYYY-MM-DD HH:mm:ss'),
                },
              }}
            />
          </div>
        </Panel>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  appId: ownProps.params.id,
  dpId: ownProps.params.dpId,
  appState: state.app.getApp,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
};

DataPointTrend.propTypes = propTypes;

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(DataPointTrend));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/DataPointsView/coms/DataPointTrend/index.jsx